/* The frame every module dashboard sits in: page surface, title, a toolbar row
   for the period switch and drill-through buttons, then the sections.

   `loading` and `hasData` are separate on purpose. A dashboard that blanks to
   "Loading…" every time someone changes the period flickers and loses their
   place; showing the previous numbers until the new ones land reads as instant.
   So the placeholder appears on the first load only. */
import { cn } from "../../utils/tailwindUtils";
import { ContainerCard, ModuleTitleCard } from "../ui/cards";

export const DashboardShell = ({
    Icon,
    title,
    subtitle,
    toolbar,
    actions,
    loading = false,
    hasData = false,
    children,
}) => (
    <ContainerCard scrollable>
        <ModuleTitleCard Icon={Icon} title={title} subtitle={subtitle} />

        {(toolbar || actions) && (
            <div className="mb-3 flex flex-wrap items-center justify-between gap-3 px-3">
                {toolbar || <span />}
                {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
            </div>
        )}

        {loading && !hasData ? (
            <p className="py-12 text-center text-sm text-muted-foreground">Loading…</p>
        ) : (
            // Refetching with numbers already on screen: keep them, but say so.
            // Swapping the figures silently meant a slow period change looked
            // like nothing had happened, and people clicked the switch again.
            // aria-busy carries the same fact to a screen reader, which the
            // fade alone does not.
            <div
                aria-busy={loading || undefined}
                className={cn(
                    "space-y-4 px-3 pb-6 transition-opacity duration-200",
                    loading && "opacity-60",
                )}
            >
                {children}
            </div>
        )}
    </ContainerCard>
);
